import React from 'react'
import styled from 'styled-components'

import WorksCount from './WorksCount'
import SearchButton from './button/SearchButton'
import ClearButton from './button/ClearButton'

interface PropsType {
  searchUrl: string
  worksCount: number
  onClickClearButton: () => void
}

const SearchControlBoxWrapper = styled.div`
  align-items: center;
  display: flex;
`

const ControlClearButton = styled(ClearButton)`
  margin-left: 15px;
`

const SearchControlBox = (props: PropsType) => {
  const { searchUrl, worksCount, onClickClearButton } = props

  return (
    <SearchControlBoxWrapper>
      <WorksCount count={worksCount} />
      <SearchButton searchUrl={searchUrl} />
      <ControlClearButton onClick={onClickClearButton}>すべてクリア</ControlClearButton>
    </SearchControlBoxWrapper>
  )
}

export default SearchControlBox
